import { Time } from '@angular/common';
import { AnswerModel } from './answer.model';
import { ObjectModel } from './object.model';
import { LogicResultModel } from './logic.model';
import { FormField } from '../services/text-control.service.interface';

//This is going to be used by header component
export interface EditorMetaModel {
  ctcID?: string;
  ctcFirstName?: string;
  ctcLastName?: string;
  casDescription?: string;
  casID?: string;
  filename?: string;
}

export interface DocumentModel extends EditorMetaModel {
  dcmID?: string;
  pathname?: string;
  isAbsolutePath?: number;
  createdBy?: string;
  date?: Date;
  time?: Time;
  folder?: string;
  document?: string;
  answers?: Array<AnswerModel>;
  documentAnswers?: Array<AnswerModel>;
  objects?: Map<string, Array<ObjectModel>>;
  isActiveDocument: boolean;
  praSysId?: number;
  templateId?: number;
  title?: string;
  sessionId?: string;
  saveAsPdf: boolean;
  answersChanged: boolean;
  modifiedDate?: Date;
  modifiedTime?: Time;
  modifiedBy?: string;
  txTextSessionID?: string;
  autosaveSessionId?: string;
  addr1Type?: string;
  addr1?: string;
  addr2Type?: string;
  addr2?: string;
  billingAddress?: string;
  openInAnotherSession: boolean;
  openedBy?: string;
  answerPoolId?: string;
  logicResults?: LogicResultModel[];
  answersHash?: string;
  pdfAnswersChanged: boolean;
  txdocsAnswersChanged: boolean;
  isDirty?: boolean;
  allFields?: FormField[];
}

export enum DocumentTableColumns {
  FileName = 'FileName',
  CreatedBy = 'CreatedBy',
  CreatedDate = 'CreatedDate',
  ModifiedBy = 'ModifiedBy',
  ModifiedDate = 'ModifiedDate',
}
